export default {
  Nav: {
    name: '导航栏',
    order: 0,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/nav/dark.jpg',
        text: '普通型(暗色)',
        textEn: 'Nav(dark)',
        uid: 0,
      },
      {
        src: 'https://imm.86links.com/assets/landing/nav/light.jpeg',
        text: '普通型(浅色)',
        textEn: 'Nav(light)',
        uid: 3,
      },
      {
        src: 'https://imm.86links.com/assets/landing/nav/link.jpg',
        text: 'Link 页面滚动',
        textEn: 'Link Nav',
        uid: 2,
      },
      {
        src: 'https://imm.86links.com/assets/landing/nav/user.jpg',
        text: '带用户型',
        textEn: 'User Nav',
        uid: 1,
      },
    ],
  },
  Banner: {
    name: '横幅',
    order: 1,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/banner/texty.jpg',
        text: '文字动画',
        textEn: 'Texty',
        uid: 3,
      },
      {
        src: 'https://imm.86links.com/assets/landing/banner/product-type.jpg',
        text: '产品型',
        textEn: 'Product Type',
        uid: 4,
      },
      {
        src: 'https://imm.86links.com/assets/landing/banner/left-right.jpeg',
        text: '左右型',
        textEn: 'Left And Right',
        uid: 5,
      },
      {
        src: 'https://imm.86links.com/assets/landing/banner/Banner%202.png',
        text: '居中型',
        textEn: 'Middle',
        uid: 6,
      },
      {
        src: 'https://imm.86links.com/assets/landing/banner/Banner%201.png',
        text: '左侧型',
        textEn: 'Left Side',
        uid: 7,
      },
      {
        src: 'https://imm.86links.com/assets/landing/banner/single.jpg',
        text: '单图',
        textEn: 'Single',
        uid: 0,
      },
      {
        src: 'https://imm.86links.com/assets/landing/banner/multiple.jpg',
        text: '多图',
        textEn: 'Multiple',
        uid: 1,
      },
      {
        src: 'https://imm.86links.com/assets/landing/banner/feature.jpg',
        text: '特性动画',
        textEn: 'Feature',
        uid: 2,
      },
    ],
  },
  Content: {
    name: '内容',
    order: 2,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/content/product-desc.jpg',
        text: '产品介绍',
        textEn: 'Product Desc',
        disabled: true,
        uid: 0,
      },
      {
        src:
          'https://imm.86links.com/assets/landing/content/product-feature1.jpg',
        text: '产品特性1',
        textEn: 'Product Feature 1',
        disabled: true,
        uid: 1,
      },
      {
        src:
          'https://imm.86links.com/assets/landing/content/product-feature2.jpg',
        text: '产品特性2',
        textEn: 'Product Feature 2',
        disabled: true,
        uid: 2,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/multifunction.jpg',
        text: '多功能介绍',
        textEn: 'Multifunction',
        disabled: true,
        uid: 3,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/video.jpg',
        text: 'video 展示',
        textEn: 'Video',
        uid: 4,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/case.jpg',
        text: '案例介绍',
        textEn: 'Case',
        uid: 5,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/single-module.jpg',
        text: '单模块介绍',
        textEn: 'Single Module',
        disabled: true,
        uid: 6,
      },
      {
        src:
          'https://imm.86links.com/assets/landing/content/multiple-modules.jpg',
        text: '多模块介绍',
        textEn: 'Multiple Modules',
        disabled: true,
        uid: 7,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/guest.jpg',
        text: '嘉宾介绍',
        textEn: 'Guest',
        disabled: true,
        uid: 8,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/timeline.jpg',
        text: '时间日程',
        textEn: 'Timeline',
        uid: 9,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/address.jpg',
        text: '大会地址',
        textEn: 'Address',
        disabled: true,
        uid: 10,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/title-text.jpg',
        text: '标题文字',
        textEn: 'Title Text',
        uid: 13,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/title-button.jpg',
        text: '标题按钮',
        textEn: 'Title Button',
        uid: 11,
      },
      {
        src: 'https://imm.86links.com/assets/landing/content/no-text.jpg',
        text: '案例介绍2',
        textEn: 'No Text',
        uid: 12,
      },
    ],
  },
  Contact: {
    name: '联系',
    order: 3,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/contact/address.jpg',
        text: '大会地址',
        textEn: 'Address',
        uid: 0,
      },
    ],
  },
  Feature: {
    name: '特性介绍',
    order: 4,
    data: [
      {
        src:
          'https://imm.86links.com/assets/landing/feature/product-feature1.jpg',
        text: '产品特性1',
        textEn: 'Product Feature 1',
        uid: 1,
      },
      {
        src:
          'https://imm.86links.com/assets/landing/feature/product-feature2.jpg',
        text: '产品特性2',
        textEn: 'Product Feature 2',
        uid: 2,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/statistics.jpeg',
        text: '数值统计',
        textEn: 'Statistics',
        uid: 6,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/product-desc.jpg',
        text: '产品介绍',
        textEn: 'Product Desc',
        uid: 0,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/card.jpeg',
        text: '卡片介绍',
        textEn: 'Card',
        uid: 7,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/multifunction.jpg',
        text: '多功能介绍',
        textEn: 'Multifunction',
        uid: 3,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/single-module.jpg',
        text: '单模块介绍',
        textEn: 'Single Module',
        uid: 4,
      },
      {
        src:
          'https://imm.86links.com/assets/landing/feature/multiple-modules.jpg',
        text: '多模块介绍',
        textEn: 'Multiple Modules',
        uid: 5,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/process.jpeg',
        text: '流程介绍',
        textEn: 'Process',
        uid: 8,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature7.png',
        text: '园区荣誉',
        textEn: 'Honor',
        uid: 9,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature18.png',
        text: '园区荣誉2',
        textEn: 'Honor2',
        uid: 18,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature98.png',
        text: 'photo-right-1',
        textEn: 'photo-right-1',
        uid: 98,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature99.png',
        text: 'photo-right-2',
        textEn: 'photo-right-2',
        uid: 99,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature8.png',
        text: '信息介绍',
        textEn: 'Message',
        uid: 10,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature12.png',
        text: '战略新兴产业',
        textEn: 'introduction',
        uid: 12,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature3.png',
        text: '产业优势',
        textEn: 'Industrial Strength',
        uid: 13,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature21.png',
        text: '产业优势2',
        textEn: 'Industrial Strength2',
        uid: 21,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature9.png',
        text: '投资载体',
        textEn: 'Investment vehicle',
        uid: 14,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature5.png',
        text: '汽车主导产业',
        textEn: 'Car',
        uid: 15,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature1.png',
        text: '交通优势',
        textEn: 'Transportation Advantage',
        uid: 11,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature16.png',
        text: '现代服务业',
        textEn: 'modern',
        uid: 16,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature17.png',
        text: '现代服务业（蓝版）',
        textEn: 'modern',
        uid: 17,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature19.png',
        text: '战略新兴产业（蓝版）',
        textEn: 'introduction',
        uid: 19,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature20.png',
        text: '交通优势（蓝版）',
        textEn: 'Transportation Advantage',
        uid: 20,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Waterfall.jpeg',
        text: '瀑布流',
        textEn: '瀑布流',
        uid: 22,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Waterfall2.jpeg',
        text: '瀑布流-左右',
        textEn: '瀑布流-左右',
        uid: 23,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature24_4.png',
        text: '文案1',
        textEn: '文案1',
        uid: 24,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature25_1.png',
        text: '文案2',
        textEn: '文案2',
        uid: 25,
      },
      {
        src: 'https://imm.86links.com/assets/landing/feature/Feature26_1.png',
        text: '文案3',
        textEn: '文案3',
        uid: 26,
      },
    ],
  },
  Pricing: {
    name: '数据介绍',
    order: 5,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/pricing/product.jpeg',
        text: '产品价格',
        textEn: 'Product',
        uid: 0,
      },
      {
        src: 'https://imm.86links.com/assets/landing/pricing/card-block.jpeg',
        text: '价目表块',
        textEn: 'Card Block',
        uid: 1,
      },
      {
        src: 'https://imm.86links.com/assets/landing/pricing/card-table.jpeg',
        text: '价目表-表格',
        textEn: 'Card Table',
        uid: 2,
      },
      {
        src:
          'https://86imm.oss-cn-hangzhou.aliyuncs.com/assets/landing/pricing/Pricing-halfscreen.png',
        text: '人才优势',
        textEn: 'halfscreen',
        uid: 3,
      },
    ],
  },
  Teams: {
    name: '人特介绍',
    order: 6,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/teams/celebrity.jpeg',
        text: '名人名言',
        textEn: 'Celebrity',
        uid: 0,
      },
      {
        src: 'https://imm.86links.com/assets/landing/teams/team-member.jpeg',
        text: '团队成员',
        textEn: 'Team Member',
        uid: 1,
      },
      {
        src: 'https://imm.86links.com/assets/landing/teams/team-member2.jpeg',
        text: '团队成员2',
        textEn: 'Team Member 2',
        uid: 2,
      },
      {
        src: 'https://imm.86links.com/assets/landing/teams/team-member3.jpeg',
        text: '团队成员3',
        textEn: 'Team Member 3',
        uid: 3,
      },
      {
        src: 'https://imm.86links.com/assets/landing/teams/guest.jpg',
        text: '嘉宾介绍',
        textEn: 'Guest',
        uid: 4,
      },
    ],
  },
  Footer: {
    name: '页脚',
    order: 7,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/footer/simple.jpg',
        text: '简单型',
        textEn: 'Simple',
      },
      {
        src: 'https://imm.86links.com/assets/landing/footer/information.jpg',
        text: '带信息',
        textEn: 'Information ',
      },
      {
        src: 'https://imm.86links.com/assets/landing/footer/share.jpg',
        text: '带分享',
        textEn: 'Share',
      },
      {
        src: 'https://imm.86links.com/assets/landing/footer/footer3.png',
        text: 'footer3',
        textEn: 'footer3',
      },
      {
        src: 'https://imm.86links.com/assets/landing/footer/footer4.png',
        text: 'footer4',
        textEn: 'footer4',
      },
    ],
  },
  Other: {
    name: '其他',
    order: 4,
    data: [
      {
        src: 'https://imm.86links.com/assets/landing/other/point.jpg',
        text: '分屏锚点圆点',
        value: 'point',
      },
      {
        src: 'https://imm.86links.com/assets/landing/other/video.mp4',
        text: '整屏滚动',
        value: 'full',
        isVideo: true,
      },
    ],
  },
};
